import React, { Component } from 'react'
import Loading from '../components/Loading'
import { connect } from 'react-redux'
import { logout } from '../actions/auth'
import { push } from '../history'

@connect(null, {logout})
export default class Logout extends Component {
  componentDidMount () {
    this.props.logout()
    push('/login')
  }

  render () {
    return <div>
      <Loading type='container' />
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/containers/Logout.js